import { render } from "./MarketingNotificationDatatableActions.vue?vue&type=template&id=d0311824"
import script from "./MarketingNotificationDatatableActions.vue?vue&type=script&lang=js"
export * from "./MarketingNotificationDatatableActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__